import { AsyncPipe } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { filter, tap } from 'rxjs';

import { StateProvinceDropdownComponent } from '@offconon/shared/ui/state-province-dropdown';

import { SharedUiFormElementsCountrySelectListModule } from '../../shared-ui-form-elements-country-select-list.module';
import { fetchCountryList } from '../../store/country.actions';
import { selectCountryList } from '../../store/country.selectors';

@Component({
  selector: 'offconon-country-with-state-select-dropdown',
  templateUrl: './country-with-state-select-dropdown.component.html',
  styleUrls: ['./country-with-state-select-dropdown.component.scss'],
  imports: [
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    StateProvinceDropdownComponent,
    AsyncPipe,
    TranslateModule,
    SharedUiFormElementsCountrySelectListModule,
  ],
})
export class CountryWithStateSelectDropdownComponent {
  @Input() stateFormControl: FormControl;
  @Input() countryFormControl: FormControl;
  private store$ = inject(Store);

  countryList$ = this.store$.select(selectCountryList).pipe(
    filter((res) => res !== undefined),
    tap((countries) => {
      if (!this.countryFormControl?.value) {
        this.countryFormControl.patchValue(countries?.[0]?.id);
      }
    }),
  );

  constructor() {
    this.store$.dispatch(fetchCountryList());
  }
}
